import publicUrls from "../../../routes/publicUrls";
import React from "react";
import { Box, Typography } from "@mui/material";

import Section from "../../../components/gallery/Section";
import SectionHeader from "../../../components/gallery/SectionHeader";
import { tokens } from "../../../theme/galleryTheme";

/**
 * "Visit our galleries" — links to the existing /location pages (same three that the
 * main menu lists). Text only: no new images are introduced.
 */
const GALLERIES = [
  { name: "León Gallery Main", href: publicUrls.location("main") },
  { name: "León Gallery International", href: publicUrls.location("international") },
  { name: "León Gallery La Fuerza", href: publicUrls.location("lafuerza") },
];

export default function GalleriesSection() {
  return (
    <Section labelledBy="home-galleries-title">
      <SectionHeader id="home-galleries-title" eyebrow="Visit" title="Our galleries" />
      <Box
        component="ul"
        sx={{
          listStyle: "none",
          m: 0,
          p: 0,
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(3, minmax(0, 1fr))" },
          gap: { xs: 2, md: 4 },
        }}
      >
        {GALLERIES.map((g) => (
          <Box component="li" key={g.href}>
            <Box
              component="a"
              href={g.href}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                minHeight: 88,
                px: 3,
                border: `1px solid ${tokens.color.line}`,
                color: tokens.color.ink,
                textDecoration: "none",
                transition: "border-color 0.2s ease, background-color 0.2s ease",
                "&:hover": { borderColor: tokens.color.ink, bgcolor: tokens.color.ivory },
              }}
            >
              <Typography variant="h4" component="h3">
                {g.name}
              </Typography>
              <span aria-hidden="true">→</span>
            </Box>
          </Box>
        ))}
      </Box>
    </Section>
  );
}
